import { useHubCheckoutContext } from "hub/src/pages/checkout/context/HubCheckoutContext";
import { formatUsdString } from "shared/helpers/invoice/formatUsdString";

export const HubCheckoutInvoiceSum = () => {
  const { invoice } = useHubCheckoutContext();
  return (
    <span>
      {!!invoice?.salesTaxSum && (
        <div data-testid="order-summary-invoice-total" className="text-right">
          <span className="text-detailblock-base text-neutral-dark">
            Sales Tax:&nbsp;
          </span>
          <span className="text-detailblock-base text-neutral-dark">
            {formatUsdString(invoice?.salesTaxSum ?? 0)}
          </span>
        </div>
      )}
      <div data-testid="order-summary-invoice-total" className="text-right">
        <span className="text-detailblock-title text-neutral-dark">
          Total:&nbsp;
        </span>
        <span className="text-detailblock-title text-neutral-dark">
          {formatUsdString(invoice?.total ?? 0)}
        </span>
      </div>
    </span>
  );
};
